import { Button, Clickable, Col, Icon, Logo, Row, Text } from 'components';
import { logout } from 'lib';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { isGameDayLabAvailable } from 'screens/Admin/screens/GameDayLab/availability';

const NavBar = (props) => {
  const [menuVisible, setMenuVisible] = useState(false),
    [reportingOpen, setReportingOpen] = useState(false),
    navigate = useNavigate(),
    dispatch = useDispatch(),
    isMobile = useSelector((state) => state.appState.isMobile),
    user = useSelector((state) => state.user),
    { pathname } = useLocation(),
    { t } = useTranslation();

  const isP4PAdmin = !!user?.admin;

  function handleMenu() {
    setMenuVisible(!menuVisible);
  }

  function handleNav(route) {
    handleMenu();
    navigate(route);
  }

  const navBarClass = isMobile
    ? `fixed top-0 h-full w-[150px] bg-[#D2D8DF] shadow-[-8px_0px_32px_rgba(0,0,0,0.12)] transition-[left] duration-300 z-50 ${menuVisible ? 'left-0' : '-left-[195px]'}`
    : 'fixed top-0 h-full w-[190px] max-w-[200px] bg-[#D2D8DF] shadow-[-8px_0px_32px_rgba(0,0,0,0.12)]';

  const isActive = (route) =>
    pathname === route ||
    (route === '/admin/users' && pathname === '/admin') ||
    // The Email Manager is six pages under one route (/audience, /templates, /compose, /reports,
    // /settings), and three legacy paths that redirect into them. Its nav
    // entry should stay lit on all of them, which an exact match alone would not do.
    (route === '/admin/email' && pathname.startsWith('/admin/email/'));

  return (
    <React.Fragment>
      {isMobile && (
        <Col ht="56px" wid="100%" noFlex>
          <Row start center noFlex pad="0 16px 0 13px">
            <Clickable onClick={handleMenu} marg="0 16px 0 0">
              <Icon type="menu" dimensions={18} />
            </Clickable>

            <Logo isMobile={isMobile} />
          </Row>
        </Col>
      )}

      <div className={navBarClass}>
        <div className="flex flex-col h-full px-3 pb-6">
          {isMobile && (
            <div className="flex justify-end mb-8">
              <Row onClick={handleNav}>
                <Icon type="close" dimensions="20" />
              </Row>
            </div>
          )}

          {!isMobile && (
            <div className="flex items-center justify-center h-[54px] shrink-0">
              <img
                src={require('assets/branding/logo-black.png')}
                className="w-[160px]"
                alt="logo"
              />
            </div>
          )}

          {/* Middle: scrollable nav items */}
          <div className="flex-1 overflow-y-auto min-h-0 w-full">
            {isP4PAdmin && (
              <>
                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/users')}>
                  <Text med size="16px" col={isActive('/admin/users') ? '#fff' : '#000'}>
                    {t('admin.nav.users')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/teams')}>
                  <Text med size="16px" col={isActive('/admin/teams') ? '#fff' : '#000'}>
                    {t('admin.nav.teams')}
                  </Text>
                </button>

                <button
                  className="h-[50px] w-full"
                  onClick={() => handleNav('/admin/event-updates')}
                >
                  <Text med size="16px" col={isActive('/admin/event-updates') ? '#fff' : '#000'}>
                    {t('admin.nav.updates')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/posts')}>
                  <Text med size="16px" col={isActive('/admin/posts') ? '#fff' : '#000'}>
                    {t('admin.nav.posts')}
                  </Text>
                </button>

                {/* <button className="h-[50px] w-full" onClick={() => handleNav('/admin/stories')}>
            <Text med size='16px' col={isActive('/admin/stories') ? '#fff' : '#000'}>Stories</Text>
            </button> */}

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/products')}>
                  <Text med size="16px" col={isActive('/admin/products') ? '#fff' : '#000'}>
                    {t('admin.nav.products')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/orders')}>
                  <Text med size="16px" col={isActive('/admin/orders') ? '#fff' : '#000'}>
                    {t('admin.nav.orders')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/pricing')}>
                  <Text med size="16px" col={isActive('/admin/pricing') ? '#fff' : '#000'}>
                    {t('admin.nav.pricing')}
                  </Text>
                </button>

                {/*
              <button className="h-[50px] w-full" onClick={() => handleNav('/admin/articles')}>
              <Text med size='16px' col={isActive('/admin/articles') ? '#fff' : '#000'}>News</Text>
              </button>

              <button className="h-[50px] w-full" onClick={() => handleNav('/admin/partners')}>
              <Text med size='16px' col={isActive('/admin/partners') ? '#fff' : '#000'}>Partners</Text>
              </button>

              <button className="h-[50px] w-full" onClick={() => handleNav('/admin/events')}>
              <Text bold size='16px'>Events</Text>
              </button>
            */}

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/games')}>
                  <Text med size="16px" col={isActive('/admin/games') ? '#fff' : '#000'}>
                    {t('admin.nav.games')}
                  </Text>
                </button>

                {isGameDayLabAvailable() && (
                  <button
                    className="h-[50px] w-full"
                    onClick={() => handleNav('/admin/game-day-lab')}
                  >
                    <Text med size="16px" col={isActive('/admin/game-day-lab') ? '#fff' : '#000'}>
                      Game Day Lab
                    </Text>
                  </button>
                )}

                <button
                  className="h-[50px] w-full"
                  onClick={() => handleNav('/admin/general-settings')}
                >
                  <Text med size="16px" col={isActive('/admin/general-settings') ? '#fff' : '#000'}>
                    {t('admin.nav.generalSettings')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/fancams')}>
                  <Text med size="16px" col={isActive('/admin/fancams') ? '#fff' : '#000'}>
                    Fancams
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/insights')}>
                  <Text med size="16px" col={isActive('/admin/insights') ? '#fff' : '#000'}>
                    {t('admin.nav.insights')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/tiri')}>
                  <Text med size="16px" col={isActive('/admin/tiri') ? '#fff' : '#000'}>
                    {t('admin.nav.tiri')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/fanwave')}>
                  <Text med size="16px" col={isActive('/admin/fanwave') ? '#fff' : '#000'}>
                    {t('admin.nav.fanWave')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/goalrush')}>
                  <Text med size="16px" col={isActive('/admin/goalrush') ? '#fff' : '#000'}>
                    {t('admin.nav.goalRush')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/email')}>
                  <Text med size="16px" col={isActive('/admin/email') ? '#fff' : '#000'}>
                    {t('admin.nav.email')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/quick-quiz')}>
                  <Text med size="16px" col={isActive('/admin/quick-quiz') ? '#fff' : '#000'}>
                    {t('admin.nav.quickQuiz')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/polls')}>
                  <Text med size="16px" col={isActive('/admin/polls') ? '#fff' : '#000'}>
                    {t('admin.nav.polls')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/shoutouts')}>
                  <Text med size="16px" col={isActive('/admin/shoutouts') ? '#fff' : '#000'}>
                    {t('admin.nav.shoutouts')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/reports')}>
                  <Text med size="16px" col={isActive('/admin/reports') ? '#fff' : '#000'}>
                    Reports
                  </Text>
                </button>

                <button
                  className="h-[50px] w-full"
                  onClick={() => handleNav('/admin/live-stats-engagement')}
                >
                  <Text
                    med
                    size="16px"
                    col={isActive('/admin/live-stats-engagement') ? '#fff' : '#000'}
                  >
                    Live Stats Engagement
                  </Text>
                </button>

                <button
                  className="h-[50px] w-full"
                  onClick={() => handleNav('/admin/subscription')}
                >
                  <Text med size="16px" col={isActive('/admin/subscription') ? '#fff' : '#000'}>
                    {t('admin.nav.subscription')}
                  </Text>
                </button>

                <button
                  className="h-[50px] w-full"
                  onClick={() => handleNav('/admin/revenue/split-report')}
                >
                  <Text
                    med
                    size="16px"
                    col={isActive('/admin/revenue/split-report') ? '#fff' : '#000'}
                  >
                    {t('admin.nav.revenueSplit')}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/audit-logs')}>
                  <Text med size="16px" col={isActive('/admin/audit-logs') ? '#fff' : '#000'}>
                    {t('admin.nav.auditLogs')}
                  </Text>
                </button>

                <button
                  className="h-[50px] w-full"
                  onClick={() => handleNav('/admin/stripe-requests')}
                >
                  <Text med size="16px" col={isActive('/admin/stripe-requests') ? '#fff' : '#000'}>
                    {t('admin.nav.stripeRequests')}
                  </Text>
                </button>

                <button
                  className="h-[50px] w-full"
                  onClick={() => handleNav('/admin/reporting/webhook-logs')}
                >
                  <Text
                    med
                    size="16px"
                    col={isActive('/admin/reporting/webhook-logs') ? '#fff' : '#000'}
                  >
                    {t('admin.nav.webhookLogs')}
                  </Text>
                </button>

                <button
                  className="h-[50px] w-full"
                  onClick={() => handleNav('/admin/activity-log')}
                >
                  <Text med size="16px" col={isActive('/admin/activity-log') ? '#fff' : '#000'}>
                    {t('admin.nav.activityLog', { defaultValue: 'Activity Log' })}
                  </Text>
                </button>

                <button className="h-[50px] w-full" onClick={() => handleNav('/admin/moderation')}>
                  <Text med size="16px" col={isActive('/admin/moderation') ? '#fff' : '#000'}>
                    Moderation
                  </Text>
                </button>
              </>
            )}

            {/* Polls — P4P admins get it under Quick Quiz inside the block above; team
                (channel-owner) admins reach it here (it's their only sidebar nav item). */}
            {!isP4PAdmin && (
              <button className="h-[50px] w-full" onClick={() => handleNav('/admin/polls')}>
                <Text med size="16px" col={isActive('/admin/polls') ? '#fff' : '#000'}>
                  {t('admin.nav.polls')}
                </Text>
              </button>
            )}

            {/* GoalRush — likewise reachable by channel owners, for their own channel's rules. */}
            {!isP4PAdmin && (
              <button className="h-[50px] w-full" onClick={() => handleNav('/admin/goalrush')}>
                <Text med size="16px" col={isActive('/admin/goalrush') ? '#fff' : '#000'}>
                  {t('admin.nav.goalRush')}
                </Text>
              </button>
            )}
          </div>

          {/* Bottom: fixed buttons */}
          <div className="shrink-0 w-full pb-3 flex flex-col items-center">
            <Button
              app
              bordered
              text={t('website.goToApp')}
              marg="0 0 16px"
              onClick={() => navigate('/home')}
            />

            <Button
              textButton
              text={t('website.logout')}
              textCol="#FA3F58"
              onClick={() => logout(navigate)}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NavBar;
